module.exports = "/assets/1c4908f36e1685ecb6c20acd8b1fa62f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/XZ.png
// module id = 2014
// module chunks = 0